import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProviderHomeRoutes from "../components/provider-home/routes/provider-home.routes";
import ProviderListingRoutes from "../components/provider-listing/routes/provider-listing.routes";
import ProviderSearchFormRoutes from "../components/provider-searchForm/routes/provider-searchFrom.routes";
import ProviderTicketRoutes from "../components/provider-tickets/routes/provider-ticket.routes";
import ProviderChatRoutes from "../components/provider-chat/routes/provider-chat.routes";
import ProviderAuthRoutes from "../components/auth-provider/routes/provider-auth.routes";
import ProviderClientList from "../components/provider-clientList/routes/provider-clientList.routes";
import ProviderUserList from "../components/provider-userList/routes/provider-userList.routes";
import ProviderChatListRoutes from "../../Providers/components/provider-chatList/routes/provider-chatList.routes";
import ProviderPanelRoutes from "../../Providers/components/provider-panel/routes/provider_panel.routes";

const ProviderRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/" replace />} />
      {/* <Route path="provider"> */}
        {ProviderHomeRoutes()}
        {ProviderListingRoutes()}
        {ProviderSearchFormRoutes()}
        {ProviderTicketRoutes()}
        {/* {ProviderChatRoutes()} */}
        {ProviderAuthRoutes()}
        {ProviderClientList()}
        {ProviderUserList()}
        {ProviderChatListRoutes()}
        {ProviderPanelRoutes()}
      {/* </Route> */}
    </Routes>
  );
};

export default ProviderRoutes;